import { useInlineStep } from "../../components/design";
import { useNavigate } from "react-router-dom";
import { Button, Icon, Modal } from "../../components/design";
import useTranslator from "../../hooks/useTranslator";
import styles from "./ApplicationCreatedModal.module.css";

type Props = {
  companyName?: string;
  iframeProfile?: boolean;
  titleKey?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionLoading?: boolean;
};

const CompanyProfileCompletedModal = ({
  companyName,
  iframeProfile = false,
  titleKey = "profileCompleted",
  actionLabel,
  onAction,
  actionLoading = false,
}: Props) => {
  const inline = useInlineStep();
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const title = companyName?.trim() || _t("yourCompany", "Your company");
  const handleGo = () => navigate("/home?welcome=true");

  let action = null;
  if (actionLabel && onAction) {
    action = (
      <Button size="lg" block loading={actionLoading} onClick={onAction}>
        {actionLabel}
      </Button>
    );
  } else if (!iframeProfile) {
    action = (
      <Button size="lg" block onClick={handleGo}>
        {_t("goToMyDashboard", "Go to my dashboard")}
      </Button>
    );
  }

  return (
    <Modal
      inline={inline}
      open
      onClose={() => {}}
      dismissible={false}
      icon={
        <span className={styles.check}>
          <Icon name="check" size={28} />
        </span>
      }
      title={_t(titleKey)}
      description={!iframeProfile ? title : undefined}
      actions={action}
    />
  );
};

export default CompanyProfileCompletedModal;
